module.exports = __webpack_public_path__ + "img/52.2af95755.png";